import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useContext, useState } from 'react';
import UserContext from '~/context/common/UserContext';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import { VdpDispatcherEvent } from '~/native/vdp/dispatchers/constants';
import sendMessageToNative from './sendMessageToNative';

export default function useIsFavoriteDispatcher(): void {
  const { stockNumber, vehicleId } = useGetVehicleDetails();
  const { isFavorite } = useContext(UserVehicleContext);
  const {
    favorites: { isLoaded: isFavoritesLoaded }
  } = useContext(UserContext);
  const [checkIsFavorite, setCheckIsFavorite] = useState(false);

  // Wait a bit before checking if the vehicle is a favorite because favorites
  // loading happens before the current vehicle is marked a favorite
  useEffectOnce(
    () => {
      const t = window.setTimeout(() => {
        setCheckIsFavorite(true);
      }, 250);

      return () => clearTimeout(t);
    },
    [],
    isFavoritesLoaded
  );

  useEffectOnce(
    () => {
      if (!isFavorite) return;

      sendMessageToNative(VdpDispatcherEvent.IsFavorite, {
        stockNumber,
        vehicleId
      });
    },
    [isFavorite, stockNumber, vehicleId],
    checkIsFavorite
  );
}
